import React from "react";
import AllInquiries from "../pages/admin/AllInquiries";
import BuyerSupplier from "../pages/admin/BuyerSupplier";
import LogisticsMembers from "../pages/admin/logisticsMembers";
import ManageCertificates from "../pages/admin/ManageCertificates";
import ManageCities from "../pages/admin/ManageCities";
import ManageCountries from "../pages/admin/ManageCountries";
import ManageHsCodes from "../pages/admin/ManageHsCodes";
import ManageIndustries from "../pages/admin/ManageIndustries";
import ManageLeads from "../pages/admin/ManageLeads";
import ManagePorts from "../pages/admin/ManagePorts";
import ManageRoles from "../pages/admin/ManageRoles";
import ManageServices from "../pages/admin/ManageServices";
import MemberDetailsForm from "../pages/admin/MemberDetailsForm";
import Members from "../pages/admin/Members";
import MyInquiries from "../pages/admin/MyInquiries";
import PaidMembers from "../pages/admin/PaidMembers";
import PendingMembers from "../pages/admin/PendingMembers";
import PrekycDashboard from "../pages/admin/preKYC/PrekycDashboard";
import ProfileHistory from "../pages/admin/ProfileHistory";
import SubscriptionPlans from "../pages/admin/subscriptionPlans";
import Users from "../pages/admin/Users";
import ChangePassword from "../pages/Company/ChangePassword";
import Updateprofile from "../pages/Company/Updateprofile";
import UserSettings from "../pages/Company/UserSettings";
import ViewProfile from "../pages/Company/ViewProfile";
import DashboardPage from "../pages/DashboardPage";
//import AddShipment from "../pages/shipment/addShipment";
import ListShipment from "../pages/shipment/listShipment";
import ShipmentDetail from "../pages/shipment/shipmentDetail";
import { privateRoutePaths } from "./private.route.config";
import MockInquiries from "@/pages/admin/MockInquiries";
import MockInquiryView from "@/pages/admin/MockInquiryView";
import OtpList from "@/pages/admin/OtpList";
import MyProducts from "@/pages/admin/products/Index";
import Add from "@/components/products/Add";
import UpdateProduct from "@/components/products/Update";
import ProductRequests from "@/pages/admin/products/ProductRequests";
import LogisticInquiries from "@/pages/admin/LogisticInquiries";
import SupplierInquiries from "@/pages/admin/SupplierInquiries";
import ViewSupplier from "@/pages/admin/ViewSupplier";
import AdminChoosePlan from "@/pages/admin/AdminChoosePlan";
import PaymentSuccess from "@/pages/admin/PaymentSuccess";
import PlanSettings from "@/pages/admin/PlanSettings";
import SupplierInquiryReport from "@/pages/admin/SupplierInquiryReport";
import SupplierInquiryReportDetail from "@/pages/admin/SupplierInquiryReportDetail";
import InquiryRawData from "@/pages/admin/InquiryRawData"
import LogisticInqViewPage from "@/components/inquiry/LogisticInqViewPage";
import LogisticInquiryFormPage from "@/pages/admin/LogisticInquiryFormPage";

const privateRoutes = {
    ADMIN_DASHBOARD: {
        ...privateRoutePaths.ADMIN_DASHBOARD,
        element: <DashboardPage />,
    },
    UPDATE_COMPANY_PROFILE: {
        ...privateRoutePaths.UPDATE_COMPANY_PROFILE,
        element: <Updateprofile />,
    },
    VIEW_COMPANY_PROFILE: {
        ...privateRoutePaths.VIEW_COMPANY_PROFILE,
        element: <ViewProfile />
    },
    VIEW_LOGISTIC_PROFILE: {
        ...privateRoutePaths.VIEW_LOGISTIC_PROFILE,
        element: <ViewProfile />
    },
    MANAGE_MEMBERS: {
        ...privateRoutePaths.MANAGE_MEMBERS,
        element: <Members />
    },
    MANAGE_LOGISTIC_MEMBERS: {
        ...privateRoutePaths.MANAGE_LOGISTIC_MEMBERS,
        element: <LogisticsMembers />
    },
    MANAGE_LEADS: {
        ...privateRoutePaths.MANAGE_LEADS,
        element: <ManageLeads />
    },
    MANAGE_USERS: {
        ...privateRoutePaths.MANAGE_USERS,
        element: <Users />
    },
    MANAGE_SHIPMENTS: {
        ...privateRoutePaths.MANAGE_SHIPMENTS,
        element: <ListShipment />
    },
    MANAGE_PLANS: {
        ...privateRoutePaths.MANAGE_PLANS,
        element: <SubscriptionPlans />
    },
    MANAGE_PLAN_SETTINGS: {
        ...privateRoutePaths.MANAGE_PLAN_SETTINGS,
        element: <PlanSettings />,
    },
    MANAGE_PAID_MEMBERS: {
        ...privateRoutePaths.MANAGE_PAID_MEMBERS,
        element: <PaidMembers />
    },
    MANAGE_PENDING_MEMBERS: {
        ...privateRoutePaths.MANAGE_PENDING_MEMBERS,
        element: <PendingMembers />
    },
    ADMIN_INQUIRIES: {
        ...privateRoutePaths.ADMIN_INQUIRIES,
        element: <AllInquiries />
    },
    LOGISTIC_INQUIRIES:{
         ...privateRoutePaths.LOGISTIC_INQUIRIES,
        element: <LogisticInquiries />
    },
    ADD_LOGISTIC_INQUIRY: {
        ...privateRoutePaths.ADD_LOGISTIC_INQUIRY,
        element: <LogisticInquiryFormPage />
    },
    VIEW_LOGISTIC_INQUIRY: {
        ...privateRoutePaths.VIEW_LOGISTIC_INQUIRY,
        element: <LogisticInqViewPage />
    },
    SUPPLIER_INQUIRIES:{
         ...privateRoutePaths.SUPPLIER_INQUIRIES,
        element: <SupplierInquiries />
    },
    MANAGE_COUNTRIES: {
        ...privateRoutePaths.MANAGE_COUNTRIES,
        element: <ManageCountries />
    },
    MANAGE_CITIES: {
        ...privateRoutePaths.MANAGE_CITIES,
        element: <ManageCities />
    },
    MANAGE_INDUSTRIES: {
        ...privateRoutePaths.MANAGE_INDUSTRIES,
        element: <ManageIndustries />
    },
    MANAGE_SERVICES: {
        ...privateRoutePaths.MANAGE_SERVICES,
        element: <ManageServices />
    },
    MANAGE_HSCODE: {
        ...privateRoutePaths.MANAGE_HSCODE,
        element: <ManageHsCodes />
    },
    MANAGE_CERTIFICATES: {
        ...privateRoutePaths.MANAGE_CERTIFICATES,
        element: <ManageCertificates />
    },
    MANAGE_PORTS: {
        ...privateRoutePaths.MANAGE_PORTS,
        element: <ManagePorts />
    },
    MANAGE_ROLES: {
        ...privateRoutePaths.MANAGE_ROLES,
        element: <ManageRoles />
    },
    SHIPMENT_COMPANY_LIST: {
        ...privateRoutePaths.SHIPMENT_COMPANY_LIST,
        element: <BuyerSupplier />
    },
    SHIPMENT_TRADE_DETAIL: {
        ...privateRoutePaths.SHIPMENT_TRADE_DETAIL,
        element: <ShipmentDetail />
    },
    PRE_KYC_DASHBOARD: {
        ...privateRoutePaths.PRE_KYC_DASHBOARD,
        element: <PrekycDashboard />
    },
    MY_INQUIRIES: {
        ...privateRoutePaths.MY_INQUIRIES,
        element: <MyInquiries />
    },
    MEMBERS_FORM: {
        ...privateRoutePaths.MEMBERS_FORM,
        element: <MemberDetailsForm />
    },
    USER_SETTINGS: {
        ...privateRoutePaths.USER_SETTINGS,
        element: <UserSettings />
    },
    CHANGE_PSWD: {
        ...privateRoutePaths.CHANGE_PSWD,
        element: <ChangePassword />
    },
    PROFILE_HISTORY: {
        ...privateRoutePaths.PROFILE_HISTORY,
        element: <ProfileHistory />
    },
    MOCK_INQUIRIES: {
        ...privateRoutePaths.MOCK_INQUIRIES,
        element: <MockInquiries />
    },
    MOCK_INQUIRY_VIEW: {
        ...privateRoutePaths.MOCK_INQUIRY_VIEW,
        element: <MockInquiryView />
    },
    OTP_LIST: {
        ...privateRoutePaths.OTP_LIST,
        element: <OtpList />
    },
    MY_PRODUCTS: {
        ...privateRoutePaths.MY_PRODUCTS,
        element: <MyProducts />
    },
    MY_PRODUCTS_ADD: {
        ...privateRoutePaths.MY_PRODUCTS_ADD,
        element: <Add />
    },
    UPDATE_PRODUCT: {
        ...privateRoutePaths.UPDATE_PRODUCT,
        element: <UpdateProduct />
    },
    REQUEST_UPDATE_PRODUCT: {
        ...privateRoutePaths.REQUEST_UPDATE_PRODUCT,
        element: <UpdateProduct />
    },
    PRODUCT_REQUEST: {
        ...privateRoutePaths.PRODUCT_REQUEST,
        element: <ProductRequests />
    },
    VIEW_SUPPLIERS:{
        ...privateRoutePaths.VIEW_SUPPLIERS,
        element: <ViewSupplier />
    },
    ADMIN_CHOOSE_PLAN:{
       ...privateRoutePaths.ADMIN_CHOOSE_PLAN, 
       element: <AdminChoosePlan />
    },
    PAYMENT_SUCCESS:{
       ...privateRoutePaths.PAYMENT_SUCCESS, 
       element: <PaymentSuccess /> 
    },
    SUPPLIER_INQUIRY_REPORT : {
       ...privateRoutePaths.SUPPLIER_INQUIRY_REPORT, 
       element: <SupplierInquiryReport />
    },
    SUPPLIER_INQUIRY_REPORT_DETAIL: {
        ...privateRoutePaths.SUPPLIER_INQUIRY_REPORT_DETAIL,
        element: <SupplierInquiryReportDetail />
    },
    RAW_DATA: {
        ...privateRoutePaths.RAW_DATA,
        element: <InquiryRawData />
    },

    
}

export {
    privateRoutes
}
